import React from "react";

const SkeletonBlock = ({ className = "" }) => (
  <div
    className={`animate-pulse rounded-md ${className}`}
    style={{
      background: "var(--card-border)",
    }}
  />
);

const PageSkeleton = () => {
  return (
    <div
      className="p-6 min-h-screen"
      style={{ background: "var(--main-bg)" }}
    >
      {/* Title */}
      <SkeletonBlock className="h-8 w-72 mb-3" />

      {/* Subtitle */}
      <SkeletonBlock className="h-4 w-96 mb-8" />

      {/* Product Card */}
      <div
        className="rounded-lg border p-4 mb-6"
        style={{
          borderColor: "var(--card-border)",
        }}
      >
        <SkeletonBlock className="h-4 w-32 mb-3" />
        <SkeletonBlock className="h-4 w-48" />
      </div>

      {/* Filter Section */}
      <div
        className="rounded-lg border p-5 mb-6"
        style={{
          borderColor: "var(--card-border)",
        }}
      >
        <SkeletonBlock className="h-6 w-40 mb-6" />

        <div className="grid grid-cols-6 gap-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonBlock
              key={i}
              className="h-10 w-full"
            />
          ))}
        </div>
      </div>

      {/* Table */}
      <div
        className="rounded-lg border overflow-hidden"
        style={{
          borderColor: "var(--card-border)",
        }}
      >
        {/* Header */}
        <div className="grid grid-cols-8 gap-4 p-4 border-b">
          {Array.from({ length: 8 }).map((_, i) => (
            <SkeletonBlock
              key={i}
              className="h-4 w-full"
            />
          ))}
        </div>

        {/* Rows */}
        {Array.from({ length: 5 }).map((_, row) => (
          <div
            key={row}
            className="grid grid-cols-8 gap-4 p-4 border-b"
          >
            {Array.from({ length: 8 }).map((_, col) => (
              <SkeletonBlock
                key={col}
                className="h-4 w-full"
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PageSkeleton;